import { Content, ContentType } from './wolters-kluwer/content';
import { UUID } from '@cna/shared/generic-types';

/**
 * Represents own content inside a (sub) section
 */
export interface OwnContent extends Content {
    id?: UUID;
    /**
     * Title of own content
     */
    title: string;
    /**
     * Represents a Html text with styling information
     */
    text: string;
}

export function isOwnContent(value: unknown): value is OwnContent {
    return typeof value === 'object' && value !== null && 'type' in value && value['type'] === ContentType.Own
}
